import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const DashboardErrorState = ({ message, onRetry, translate }) => {
  return (
    <Box sx={{ py: 4 }}>
      <Alert
        severity="error"
        action={
          onRetry ? (
            <Button color="inherit" size="small" startIcon={<RefreshIcon />} onClick={onRetry}>
              {translate('home.dashboard.retry')}
            </Button>
          ) : null
        }
      >
        {message || translate('home.dashboard.load_error')}
      </Alert>
    </Box>
  );
};

export default DashboardErrorState;
